import { createAction, Dispatch } from '@reduxjs/toolkit';
import SchemaApi from '../../api/schemaApi';
import { SchemaModel } from '../../models/schemaModel';
import { AppError } from '../../types/appError';

export const setSelectedSchemaName = createAction<string>('schemas/setSelectedSchemaName');

export const schemasFetchAllRequestAction = createAction<void>('schemas/fetchAllRequest');
export const schemasFetchAllSuccessAction = createAction<SchemaModel[]>('schemas/fetchAllSuccess');
export const schemasFetchAllFailureAction = createAction<AppError>('schemas/fetchAllFailure');

export const fetchAllSchemas = () => async (dispatch: Dispatch) => {
  dispatch(schemasFetchAllRequestAction());
  try {
    const allSchemas = await SchemaApi.fetchAll();
    dispatch(schemasFetchAllSuccessAction(allSchemas));
  } catch (error) {
    dispatch(schemasFetchAllFailureAction(error as AppError));
  }
}

export const schemasFetchOneRequestAction = createAction<void>('schemas/fetchOneRequest');
export const schemasFetchOneSuccessAction = createAction<SchemaModel>('schemas/fetchOneSuccess');
export const schemasFetchOneFailureAction = createAction<AppError>('schemas/fetchOneFailure');

export const fetchSchemaByName = (schemaName: string) => async (dispatch: Dispatch) => {
  dispatch(schemasFetchOneRequestAction);
  try {
    const oneSchema = await SchemaApi.fetchSchemaByName(schemaName);
    dispatch(schemasFetchOneSuccessAction(oneSchema));
  } catch (error) {
    dispatch(schemasFetchOneFailureAction(error as AppError));
  }
}
